exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sweet-modal-overlay.theme-dark[data-v-48b7717d] {\n  background: rgba(24, 32, 40, 0.4);\n}\n.img-promotion[data-v-48b7717d] {\n  max-width: 90%;\n  border-radius: 1rem;\n}\n.section-promotions[data-v-48b7717d] .sweet-content {\n  background-color: transparent;\n  padding: 0 !important;\n}\n.section-promotions[data-v-48b7717d] .sweet-modal {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  background-color: transparent;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-48b7717d","scoped":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/promotion/Slider.vue
// module id = 1439
// module chunks = 0